import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { HttpResponseErrorInterceptor } from './http-response-error-interceptor.service';

export const HttpResponseErrorInterceptorService: string =
    ng
        .module('HttpResponseErrorInterceptorService', [
            'ui.bootstrap',
            uiRouter
        ])
        .service('httpResponseErrorInterceptor', HttpResponseErrorInterceptor)
        .config(['$httpProvider', ($httpProvider: ng.IHttpProvider) => {
            $httpProvider.interceptors.push('httpResponseErrorInterceptor');
        }])
        .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/services/http-response-error-interceptor/http-response-error-interceptor.module.ts